import { Box, IconButton } from '@mui/material'
import { GridCellParams } from '@mui/x-data-grid'
import AddIcon from '@mui/icons-material/Add'
import {
  Check,
  Close,
  FiberManualRecord,
  PriorityHigh,
} from '@mui/icons-material'
import { red } from '@mui/material/colors'

type RenderCellProps = {
  week: string
  aggregation: boolean
} & GridCellParams

export const SkuCodeRenderCell = (params: GridCellParams) => {
  return (
    <Box display="flex">
      <Box>
        <IconButton size="small" tabIndex={-1}>
          <AddIcon />
        </IconButton>
      </Box>
      <Box>{params.row.skuCode}</Box>
    </Box>
  )
}

export const ProposedProductionAmountRenderCell = (params: RenderCellProps) => {
  const { row, week } = params
  if (params.aggregation) {
    // If this method is called for aggregation, return the value as it is.
    return params.formattedValue
  }
  if (row[week]?.proposedProductionAmount > 0 && !row[week]?.templateWeek) {
    return (
      <Box
        sx={{
          color: red,
        }}
      >
        {row[week]?.proposedProductionAmount}
        <PriorityHigh sx={{ color: 'red' }} />
      </Box>
    )
  }
  return <Box>{row[week]?.proposedProductionAmount}</Box>
}

export const TemplateWeekRenderCell = (params: RenderCellProps) => {
  const { row, week } = params
  if (params.aggregation) {
    // If this method is called for aggregation, return the value as it is.
    return '-'
  }
  if (row[week]?.templateWeek) {
    return <Check />
  } else {
    return <Close />
  }
}

export const ExcessDaysProjectedRenderCell = (params: RenderCellProps) => {
  const { row, week } = params
  if (params.aggregation) {
    // If this method is called for aggregation, return the value as it is.
    return params.formattedValue
  }
  if (row[week]?.excessDaysProjected < 0) {
    return (
      <Box width="100%">
        {row[week]?.excessDaysProjected}{' '}
        <FiberManualRecord
          sx={{
            color: '#FFBF00',
          }}
        />
      </Box>
    )
  }
  return <Box>{row[week]?.excessDaysProjected}</Box>
}
